export const PERMISOS = {
    VIEW_HOME: 'VIEW_HOME',
    VIEW_USER: 'VIEW_USER',
    VIEW_NOTIFICATION: 'VIEW_NOTIFICATION',
} as const
